import { LazyQueryExecFunction, OperationVariables } from '@apollo/client'
import { CircularProgress, Typography } from '@material-ui/core'
import ApartmentIcon from '@material-ui/icons/Apartment'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'

import { DateObject } from '../../helpers/date'
import { getTranslate } from '../../localization'
import {
  MonitoringUpdateAccommodationLayer,
  MonitoringUpdateRoomTypeLayerResponse
} from '../../types/monitoringUpdate'
import useStyles from './Styles/AccommodationLayer.style'
import TimeCell from './TimeCell'

interface AccommodationLayerProps {
  range: 'TWO_WEEKS' | 'MONTH'
  data: MonitoringUpdateAccommodationLayer
  setShowRoomType: React.Dispatch<React.SetStateAction<boolean>>
  showRoomType: boolean
  weekendIndexes: number[]
  showChannels: any
  showChannelsLayer: boolean
  setChannelsLayer: React.Dispatch<React.SetStateAction<boolean>>
  getMonitoringRoomTypeData: LazyQueryExecFunction<
    {
      getUpdateMonitoringRoomTypeLayer: MonitoringUpdateRoomTypeLayerResponse
    },
    OperationVariables
  >
  inventoryTypeAutocomplete: any
  statusAutocomplete: any
  selectedDateInDatePicker: DateObject
  loadingForRoomType: boolean
  currentIndexAccommodationLayer: number
  setCurrentIndexAccommodationLayer: React.Dispatch<
    React.SetStateAction<number>
  >
  accommodationIndex: number
}

export default function AccommodationLayer({
  range,
  data,
  setShowRoomType,
  showRoomType,
  weekendIndexes,
  showChannels,
  showChannelsLayer,
  setChannelsLayer,
  getMonitoringRoomTypeData,
  inventoryTypeAutocomplete,
  statusAutocomplete,
  selectedDateInDatePicker,
  loadingForRoomType,
  accommodationIndex,
  setCurrentIndexAccommodationLayer,
  currentIndexAccommodationLayer
}: AccommodationLayerProps) {
  const classes = useStyles()

  const onClickRoomType = (index: number) => {
    if (showChannels) {
      setChannelsLayer(!showChannelsLayer)
    } else {
      setShowRoomType(!showRoomType)
      setCurrentIndexAccommodationLayer(index)
      getMonitoringRoomTypeData({
        variables: {
          filters: {
            inventoryType:
              inventoryTypeAutocomplete && inventoryTypeAutocomplete.value,
            from: selectedDateInDatePicker.gregorianStartDate,
            to: selectedDateInDatePicker.gregorianEndDate,
            updateHealthStatus: statusAutocomplete
              ? statusAutocomplete.value
              : undefined,
            propertyCode: data.propertyCode
          }
        }
      })
    }
  }

  return (
    <div>
      <div
        className={[
          classes.accommodationRow,
          range === 'MONTH' ? classes.accommodationRowRowForMonth : ''
        ].join(' ')}>
        <div className={classes.accommodationContainer}>
          <div className={classes.accommodationIcon}>
            <ApartmentIcon />
          </div>
          <Typography variant="h5" className={classes.accommodationName}>
            {data.accommodationName}
          </Typography>
          <Typography
            variant="h6"
            className={classes.numberOfRoomType}
            component="span"
            onClick={() => onClickRoomType(accommodationIndex)}>
            {showChannels ? (
              <>
                {data.channels.length} {getTranslate('Channels')}
              </>
            ) : (
              <>
                {data.numberOfRoomType} {getTranslate('Room Type')}
              </>
            )}
          </Typography>
          <div className={classes.roomTypeLoading}>
            {!showChannels &&
            loadingForRoomType &&
            accommodationIndex === currentIndexAccommodationLayer ? (
              <CircularProgress size={12} />
            ) : (
              <ArrowRightIcon
                onClick={() => onClickRoomType(accommodationIndex)}
                className={[
                  classes.channelArrowRight,
                  showRoomType || showChannelsLayer
                    ? classes.channelArrowRightCollapsed
                    : ''
                ].join(' ')}
              />
            )}
          </div>
        </div>
        {data.dataForEachDate.map((dataStatus, index) => {
          return (
            <div
              key={index}
              className={[
                classes.dayContainer,
                weekendIndexes.includes(index % 7)
                  ? classes.weekendDayContainer
                  : ''
              ].join(' ')}>
              <TimeCell dataStatus={dataStatus} range={range} />
            </div>
          )
        })}
      </div>
    </div>
  )
}
